<template>
  <v-form
    ref="form"
    :value="valid"
    @input="v => $emit('update:valid', v)"
    @submit.prevent=""
  >
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="contact_name"
          @change="v => $emit('update:contact_name', v)"
          label="Nom"
          prepend-icon="fa-user-tie"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="10" sm="6">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="contact_phone"
          @change="v => $emit('update:contact_phone', v)"
          label="Téléphone"
          mask="phone"
          prepend-icon="fa-phone"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="contact_poste"
          @change="v => $emit('update:contact_poste', v)"
          label="Poste"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="contact_email"
          @change="v => $emit('update:contact_email', v)"
          label="Courriel"
          prepend-icon="fa-at"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-textarea
          filled
          dense
          class="no-before"
          :value="comments"
          @change="v => $emit('update:comments', v)"
          label="Commentaires"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: "SupplierStoreFields",
  props: {
    contact_name: {
      required: true
    },
    contact_phone: {
      required: true
    },
    contact_poste: {
      required: true
    },
    contact_email: {
      required: true
    },
    comments: {
      required: true
    },
    valid: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style></style>
